import { PendingQueueItemKeyWithoutSequence } from '../../core/database/pendingQueue/pendingQueueStorage';
import { PartialSheetManagementSet, RawCommandsHistory } from '../types/sheet/draft';

export enum SheetSharedStorageWorkerResponse {
  Error = 'Error',
  SyncEvents = 'SyncEvents',
}

export enum SheetSharedStorageWorkerMessageType {
  SyncAndSaveSheetSet = 'SyncAndSaveSheetSet',
  SaveSheetsCommands = 'SaveSheetsCommands',
}

export interface StartSyncSheetManagementSet {
  type: SheetSharedStorageWorkerMessageType.SyncAndSaveSheetSet;
  userId: string;
  // privateKey?: CryptoKey;
  sheetFeKeys: Map<string, CryptoKey | undefined>;
  masterFeKey?: CryptoKey;
  userFeKey?: CryptoKey;
  keyWithoutSequence: PendingQueueItemKeyWithoutSequence;
  sheetsCommands: RawCommandsHistory;
}

export interface StartSaveSheetsCommands
  extends Pick<
    StartSyncSheetManagementSet,
    'userFeKey' | 'userId' | 'sheetFeKeys' | 'sheetsCommands'
  > {
  type: SheetSharedStorageWorkerMessageType.SaveSheetsCommands;
}

// export interface SheetCommandsToBeSyncedToServer
//   extends Partial<
//     Pick<CommandHistory, 'sheetChanges' | 'entityIdToNameMapChanges'>
//   > {
//   type: SheetSharedStorageWorkerResponse.SyncEvents;
//   id: string;
//   key: PendingQueueItemKey;
//   dbSet: CommandHistoryForUnsentDB;
// }

export interface SheetStorageWorkerError {
  type: SheetSharedStorageWorkerResponse.Error;
  error: string;
}

export enum SnapshotStores {
  Base = 'Base',
  Changes = 'Changes', // Not needed in Groups
  Commands = 'Commands',
}

export const snapshotStoresSchema = Object.values(SnapshotStores).reduce(
  (stores, value) => {
    stores[value] = '++';
    return stores;
  },
  {} as { [key: string]: string }
);
